import React from 'react';
import BotSavingIndicator from '../../../common/components/BotSavingIndicator/BotSavingIndicator';
import { FreeTrialCountdown } from '../../../layout/BotBuilderSidebar/FreeTrialCountdown/FreeTrialCountdown';
import DashboardTipInfo from '../../components/DashboardTipInfo/DashboardTipInfo';
import { ToolTipInfo } from '../../constants/toolTipInfo';
import './BotPanelHeader.pcss';

type Props = {
  featureGroupName?: string;
  featureGroupOnClick?: (e?: any) => void;
  panelName?: string;
  panelOnClick?: (e?: any) => void;
  itemName?: string | null;
  itemOnClick?: (e?: any) => void;
  tipInfo?: ToolTipInfo;
  infoText?: string;
  customToolTip?: string | React.ReactNode;
  customLeftPanelContent?: string | React.ReactNode;
  rightPanelContent?: string | React.ReactNode;
  showSavingIndicator?: boolean;
};

const BotPanelHeader = (props: Props) => {
  const {
    featureGroupName,
    featureGroupOnClick,
    showSavingIndicator,
    panelName,
    panelOnClick,
    itemName,
    itemOnClick,
    tipInfo,
    customToolTip,
    customLeftPanelContent,
    rightPanelContent,
    infoText,
  } = props;

  return (
    <div className="bot-panel-header">
      <div className="bot-panel-header__section-wr">
        <div className="bot-panel-header__left-section">
          {
            // Use customLeftPanelContent if you want custom left side of the menu instead of standard breadcrumbs
            customLeftPanelContent && (
              <div className="bot-panel-header__panel-name">
                {customLeftPanelContent}
              </div>
            )
          }

          {
            // Root-level breadcrumb
            featureGroupName && (
              <div
                className={
                  featureGroupOnClick
                    ? 'bot-panel-header__breadcrumb--link'
                    : 'bot-panel-header__breadcrumb'
                }
                onClick={featureGroupOnClick ? featureGroupOnClick : () => {}}
              >
                {featureGroupName}
              </div>
            )
          }

          {panelName && (
            <div
              className={
                panelOnClick
                  ? 'bot-panel-header__breadcrumb--link'
                  : 'bot-panel-header__breadcrumb'
              }
              onClick={panelOnClick ? panelOnClick : () => {}}
            >
              {` / ${panelName}`}
            </div>
          )}

          {itemName && (
            <div
              className={
                itemOnClick
                  ? 'bot-panel-header__breadcrumb--link'
                  : 'bot-panel-header__breadcrumb'
              }
              onClick={itemOnClick ? itemOnClick : () => {}}
            >
              {` / ${itemName}`}
            </div>
          )}

          {tipInfo && <DashboardTipInfo toolTipInfo={tipInfo} />}

          {customToolTip}

          {showSavingIndicator && <BotSavingIndicator />}
        </div>

        <div className="bot-panel-header__right-section">
          {featureGroupName === 'Home' && (
            <div className="bot-panel-head__free-trial">
              <FreeTrialCountdown />
            </div>
          )}

          {rightPanelContent && (
            <div className="bot-panel-header__extra-content">
              {rightPanelContent}
            </div>
          )}
        </div>
      </div>
      {infoText && (
        <div className="bot-panel-header__info-text">{infoText}</div>
      )}
    </div>
  );
};

export default BotPanelHeader;
